<template src= "./registration.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'
import $api from '@/plugins/axiosInstance.js'
import swal from 'sweetalert2'
import agTableComp from '@/optionData/agTableComp'
import axios from 'axios'
import { getMetadata, getThumbnails } from 'video-metadata-thumbnails';


export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">{{title}}</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.title ? this.params.title : '선택'
    
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const BtnDelete = Vue.extend({
  name : 'btnDelete',
  template: `
        <button style="height:30px; line-height:30px; padding:0 1rem;" @click="btnClickedHandler()" type="button" name="button" class="vs-component vs-button vs-button-dark vs-button-filled" >
          <span class="vs-button-text vs-button--text"> {{title}} </span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);">
          </span>
        </button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const DownLink = Vue.extend({
  name : 'downLink',
  template: `
      <a  target='_blank' :href='file' @click="btnClickedHandler2()" download>{{title}}</a>
    `,
  data(){
    return{
      title : '',
      name : '',
      file : ''
    }
  },
  created(){
    this.title = this.params.data.display_name
    this.file = this.params.data.remote_path
  },
  methods: {
    btnClickedHandler2() {
    }
  },
});
export const Radio = Vue.extend({
   name : 'radio',
  template: `
    <div style="height:100%; display:flex" >
      <vs-radio :disabled="disabled"  vs-name="checkLicensor"  v-model="check" :vs-value="value"></vs-radio>
    </div>
    `,
  data(){
    return{
      check : null,
      value : null,
      disabled : false
    }
  },
  watch :{
    'check'(e){
      this.btnClickedHandler()
    }
  },
  created(){
    this.check = this.params.context.componentParent.selectLicensor ? this.params.context.componentParent.selectLicensor.id : null
    this.value = this.params.value
    if(this.params.data.licensor.contractor_id != null) {
      this.disabled =true
    }
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
  
})
export const CheckBox = Vue.extend({
  name : 'checkBox',
  template: `

      <vs-checkbox class="inline-flex mt-2" v-model="check"></vs-checkbox>
    `,
  data(){
    return{
      check : false,
      value : {},
      disabled : false
    }
  },
  watch :{
    'check'(e){
      
      this.btnClickedHandler()
      let a = this.params.context.componentParent.selectAlbum
      const idx = a.findIndex((item) => {return item.id === this.value.id})
      if(e == true){
        if(idx < 0){
          this.params.context.componentParent.selectAlbum.push(this.value);
        }
      }else{
        this.params.context.componentParent.selectAlbum.splice(idx,1)
      }
    }
  },
  
  created(){
    let t = this.params.context.componentParent.selectAlbum
    this.value = this.params.data
    for(var i in t){
      if(t[i].id == this.value.id){
        this.check = true
      }
    }
    
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
  name: 'albumDetail',
  data() {
    return {
      
      ko : ko,
      //
      gridOptions :{ // 테이블 옵션
        context: {
          componentParent: this
        },
        onRowClicked: (event)=>{
            
        },
      },
      gridOptions2 :{ // 테이블 옵션
        context: {
          componentParent: this
        },
        onRowClicked: (event)=>{
            
        },
      },
      defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          
          suppressMenu: false,
          rowSelection:'single'
      },
      columnDefs: [
        {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
        {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
          cellRenderer: (data) => {
            let name = `${(data.data.licensor.family_name ? data.data.licensor.family_name : '')} ${(data.data.licensor.given_name ? data.data.licensor.given_name : '')}`
            var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
            if(pattern3.test(name)){
                name = `${(data.data.licensor.family_name ? data.data.licensor.family_name : '')} ${(data.data.licensor.given_name ? data.data.licensor.given_name : '')}`
            }else{
                name = `${(data.data.licensor.given_name ? data.data.licensor.given_name : '')} ${(data.data.licensor.family_name ? data.data.licensor.family_name : '')}` 
            }
                
          return name 
        }},
        {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,
          cellRenderer: (data) => {
            
          let company = data.value ? data.value : ''
          return company 
        }},
        {headerName: '사업자구분', field: 'licensor.entity', filter: false,width: 150,
            cellRenderer: (data) => {
            let dd ={
                'corporation': '사업자',
                'individual' :'개인'
            }
            let val = data.value ? data.value : ''
            let text = dd[val];
            if(data.value == 'corporation'){
              
              if( data.data.entity_tax_exemption == true){
                  text = dd[val] + ' (면세)'    
              }else{
                  text = dd[val] + ' (비면세)'    
              }
            }
            
            return text
        }},
        {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 100,
          cellRenderer: (data) => {
            
            return data.value.toUpperCase()
        }},
        {headerName: '잔액', field: 'licensor.balance', filter: false,width: 150,
          cellRenderer: (data) => {
            
            return  this.numberFormat(data.value) + ' ' + data.data.licensor.currency.toUpperCase()
        }},
        {headerName: '거주국가(세율)', field: 'licensor.entity_address', filter: false,width: 190,
          cellRenderer: (data) => {
            let text = `
              ${data.value.country} (${data.data.licensor.entity_tax_rate}%)
            `
            return text
        }},
        {headerName: '기본정산요율', field: 'licensor.currency', filter: false,width: 190,
          cellRenderer: (data) => {
            let t1 = "한국 : "  +data.data.licensor.default_service_fee_kr
            let t2 = "해외 : "  +data.data.licensor.default_service_fee_other
            
            
            
            return `${t1}% \ ${t2}%`
        }},
        {headerName: '상세보기', field: 'id', filter: false,width: 120,cellRenderer: (data) => {
          return `
          <a class="vs-component vs-button mr-3 vs-button-primary vs-button-gradient" href='/member/detail/${data.value}' target="_blank">
          
          <span class="vs-button-text vs-button--text">상세보기</span>
          </a>`
        }},
      ],
     
      // 라이센서 추가
      gridOptions5 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
            componentParent: this
        },
        onGridReady: function (event) {
        },
        frameworkComponents : {
          btnSelect : BtnSelect
        }
      },
      columnDefsUser : [
          {headerName: '선택', field: 'email', filter: false,width: 100,
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.selectLicensorData(data)
                this.context.componentParent.closeModal('licensor')
              }
            },
            cellRenderer: 'btnSelect'
          },
          {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
          {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
            cellRenderer: (data) => {
              let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
              return fm +' '+ gm
          }},
          {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
          
          {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
            cellRenderer: (data) => {
              const type = {
                  'krw' : 'KRW',
                  'usd' : 'USD',
                  'eur' : 'EUR',
              }
              return type[data.value]
          }},
          {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
              const type = {
                  'individual' : '개인',
                  'corporation' : '사업자',
              }
              return type[data.value]
          }},
          {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
          {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
          {headerName: '정산요율', field: 'licensor.default_service_fee_kr', filter: false,width: 200, cellRenderer: (data) => {
              let text = ""
              text += "국내 : " + data.value + '%   '
              text += "해외 : " + data.data.licensor.default_service_fee_other + '%'
              return text
          }},
      ],
      keywordType : {label:'권리자명', value:'_name'},
      licensorKeyword : '',
      memberOption : optionData.memberKeyword,
      userList: {
        listData: [],                 
        pageSize: 10,                 
        currentPage: 1,
        totalPage: 0,                
      },
      gridOptionsUser :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
          componentParent: this
        },
        onGridReady: function (event) {
        },
        frameworkComponents :agTableComp,
      },
      ////// 앨범
      albumGridOptions : {
        frameworkComponents :agTableComp,
      },
      //앨범 찾기 
      albumList : {
        keywordType : null,
        keyword : null,
        listData: [],                 
        pageSize: 5,                 
        currentPage: 1,
        totalPage: 0,
        total : 0,
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          frameworkComponents : {
            btnDelete : BtnDelete,
            downLink : DownLink,
            radio : Radio,
            checkBox : CheckBox,
            textRender : agTableComp.textRender
          }
        },
        columnDefs : [
          
          {headerName: '선택',  field: 'release_date',  filter: false,width: 130,
            cellRendererParams: {
              clicked: function(data) {
                
                //this.context.componentParent.closeModal('licensor')
              }
            },
            cellRendererSelector: (data) => {
                if( data.data.advancepayment_id){
                  return { 
                    component: 'textRender',
                    params: {
                      text: '선급금상계대상'
                    }
                  }
                }else{
                  return { 
                    component: 'checkBox',
                    params: {
                      ...data.data,
                    }
                  }
                }
            }
          },
          {headerName: '발매일',  field: 'release_date',  filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 150},
          {headerName: '앨범명', field: 'name', filter: false,width: 200,},
          {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
            cellRenderer: (data) => {
              let t = data.value
              let text =  ''
              for ( var i in t ){
                if(i != 0){
                  text += ', '
                }
                text += t[i].display_name
                
              }
              return text
          }},
          {headerName: '트랙수', field: 'track_count', filter: false,width: 120,},
        ],
      },
      albumOption :[
        {value: 'name', label:'앨범명'},
        {value: 'album_ref',label: '자사앨범코드'},
        {value: 'barcode',label: 'UPC',},
        {value: 'artist',label: '아티스트명',},
        {value: 'artist_english',label: '아티스트명(번역)',},
      ],
      selectAlbumColum : [
          {headerName: '상태',  field: 'state',  filter: false,width: 100, cellRenderer: (data) => {
              let dd = {
                  temporary :'임시저장',
                  registration_complete : '접수', 
                  registration_canceled : '유통 취소', 
                  inspection_complete : '검수 완료', 
                  distribution_complete : '유통 완료', 
                  release_complete : '발매 완료', 
                  suspended : '유통중단', 
                  rejected : '반려',
                  trash : '임시삭제'
              }
              let color = {
                  temporary : "#9544d0b3",//'임시저장',
                  registration_complete : '#262c49',//'접수', 
                  registration_canceled : '#797979',//'유통 취소', 
                  inspection_complete : '#4092ff',//'검수 완료', 
                  distribution_complete : '#ff9f43',//'유통 완료', 
                  release_complete : '#24c1a0',//'발매 완료', 
                  suspended : '#b8c2cc',//'유통중단', 
                  rejected : '#ea5455',//'반려' 
                  trash : "#737373"
              }
          return `
          <div class="con-vs-chip vs-chip-primary con-color" 
          style="
              background-color: ${color[data.value]} !important;
              color:#fff;
              line-height:1;
              padding:3px 5px;
              margin:13px 0; 
              font-size:13px;
              min-width:50px;
          ">
              <span style="margin:0" class="text-chip vs-chip--text">
              ${dd[data.value]}
          </span><!----></div>`
          }},
          {headerName: '발매일',  field: 'release_date',  filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 150},
          {headerName: '앨범명', field: 'name', filter: false,width: 200,},
          {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
            cellRenderer: (data) => {
              let t = data.value
              let text =  ''
              for ( var i in t ){
                if(i != 0){
                  text += ', '
                }
                text += t[i].display_name
                
              }
              return text
          }},
          {headerName: '트랙수', field: 'track_count', filter: false,width: 120,},
          {headerName: '상세보기', field: 'id', filter: false,width: 120,cellRenderer: (data) => {
          return `
          <a class="vs-component vs-button mr-3 vs-button-primary vs-button-gradient" href='/album/detail/${data.value}' target="_blank">
          
          <span class="vs-button-text vs-button--text">상세보기</span>
          </a>`
        }},
      ],

      selectAlbum : [
      ],


      old_licensor : [],
      new_licensor : [],
      description : null,
      change_album_service_fee : true, // 정산요율 설정
      all_album : false , // 전체이관 여부
    }
  },
  mounted(){
 
   this.$nextTick((vue) =>{
      if(this.$route.params){
        //this.datacall();
     
      }
    })
  },
  watch:{
    'userList.currentPage'(){
      this.getUserList()
    },
    
    'albumList.currentPage'(){
      this.getUserAlbumList()
    },
  },
  computed:{
    
  },
  methods: {
    saveTransfer(){

      if(this.old_licensor.length < 1 ){
        this.alert({msg:'양도자를 선택해주세요.'}) 
        return false
      }
      if(this.new_licensor.length < 1 ){
        this.alert({msg:'양수자를 선택해주세요.'}) 
        return false
      }
      let album =[]
      if(this.all_album) {
       album = []
      }else{
        if(this.selectAlbum.length < 1 ){
          this.alert({msg:'이관 대상 앨범을 선택해주세요.'})
          return false
        }
        album = []
        for(let i in this.selectAlbum){
          album.push(this.selectAlbum[i].id)
        }
      }
     
      let payload = {
        params:{
          albums :album,
          old_licensor_id: this.old_licensor[0].licensor.id,
          new_licensor_id: this.new_licensor[0].licensor.id,
          description : this.description,
          change_album_service_fee  : this.change_album_service_fee
        }
      }

      


       let oldName = `${(this.old_licensor[0].licensor.family_name ? this.old_licensor[0].licensor.family_name : '')} ${(this.old_licensor[0].licensor.given_name ? this.old_licensor[0].licensor.given_name : '')}`
       let newName = `${(this.new_licensor[0].licensor.family_name ? this.new_licensor[0].licensor.family_name : '')} ${(this.new_licensor[0].licensor.given_name ? this.new_licensor[0].licensor.given_name : '')}`
        var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
        if(pattern3.test(oldName)){
            oldName = `${(this.old_licensor[0].licensor.family_name ? this.old_licensor[0].licensor.family_name : '')} ${(this.old_licensor[0].licensor.given_name ? this.old_licensor[0].licensor.given_name : '')}`
        }else{
            oldName = `${(this.old_licensor[0].licensor.given_name ? this.old_licensor[0].licensor.given_name : '')} ${(this.old_licensor[0].licensor.family_name ? this.old_licensor[0].licensor.family_name : '')}` 
        }
        if(pattern3.test(newName)){
            newName = `${(this.new_licensor[0].licensor.family_name ? this.new_licensor[0].licensor.family_name : '')} ${(this.new_licensor[0].licensor.given_name ? this.new_licensor[0].licensor.given_name : '')}`
        }else{
            newName = `${(this.new_licensor[0].licensor.given_name ? this.new_licensor[0].licensor.given_name : '')} ${(this.new_licensor[0].licensor.family_name ? this.new_licensor[0].licensor.family_name : '')}` 
        }
      this.confirm({
          title : '내부이관 등록',
          msg : `
            ${this.old_licensor[0].email}(${oldName})로부터  <br/>
            앨범 ${this.all_album ? '전체를 ' : this.selectAlbum.length+'개를'}<br/>
            ${this.new_licensor[0].email}(${newName})에게 <br/>
            내부이관 하시겠습니까??
          `,
          autofocus : true,
          width:500,
          action : ()=>{
            this.loadingShow()

           
            this.$store.dispatch('POST_TRANSFER', payload)
              .then(result =>{
                 
                  this.loadingHide()
                  this.$router.push('/transfer')
              }).catch(error=>{
                const status = error.status
                this.loadingHide()
                switch(status){
                  case 401:
                  this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                  break;
                  default:
                    this.alert({msg:error})
                  break;
              }
            })
          }
      })
      
      
    },
    openLicensor(){
      this.userList.currentPage = 1
      this.keywordType =  {label:'권리자명', value:'_name'},
      this.licensorKeyword = '',
      this.columnDefsUser[0]={headerName: '선택', field: 'email', filter: false,width: 100,
        cellRendererParams: {
          clicked: function(data) {
            this.context.componentParent.selectLicensorData(data)
            
          }
        },
        cellRendererSelector: (data) => {
          if(this.new_licensor.length > 0 && this.new_licensor[0].licensor.id == data.data.licensor.id){
            let dd={
                component: 'textRender',
                params: {
                    ...data.data,
                    text: '양수자 선택',
                    style:'text-align:center'
                }
            } ;
            return dd
          }
          if(this.old_licensor.length > 0 && this.old_licensor[0].licensor.id == data.data.licensor.id){
            let dd={
                component: 'textRender',
                params: {
                    ...data.data,
                    text: '양도자 선택',
                    style:'text-align:center'
                }
            } ;
            return dd
          }
          let dd={
              component: 'btnSelect',
              params: {
                  ...data.data,
              }
          };
          return dd
      }},
      this.openModal('licensor');
      this.getUserList()
    },
    openLicensor2(){
      this.userList.currentPage = 1
      this.keywordType =  {label:'권리자명', value:'_name'},
      this.licensorKeyword = '',
       this.columnDefsUser[0]={headerName: 'z선택', field: 'email', filter: false,width: 100,
        cellRendererParams: {
          clicked: function(data) {
            this.context.componentParent.selectLicensorData2(data)
          }
        },
        cellRendererSelector: (data) => {
          if(this.new_licensor.length > 0 && this.new_licensor[0].licensor.id == data.data.licensor.id){
            let dd={
                component: 'textRender',
                params: {
                    ...data.data,
                    text: '양수자 선택',
                    style:'text-align:center'
                }
            } ;
            return dd
          }
          if(this.old_licensor.length > 0 && this.old_licensor[0].licensor.id == data.data.licensor.id){
            let dd={
                component: 'textRender',
                params: {
                    ...data.data,
                    text: '양도자 선택',
                    style:'text-align:center'
                }
            } ;
            return dd
          }
          let dd={
              component: 'btnSelect',
              params: {
                  ...data.data,
              }
          };
          return dd
      }},
      this.openModal('licensor');
      this.getUserList()
    },
    getUserList(){
        const option = {
          sort: 'created_at',
          sortorder: 'desc',
          role : 'licensor',
          page: this.userList.currentPage-1 ,
          limit: this.userList.pageSize
        }
        if(this.keywordType && this.keywordType !='') {
            option[this.keywordType.value] = this.licensorKeyword
        }
        this.loadingShow()
        this.$store.dispatch('GETUSER', option)
        .then(result =>{
            this.userList.listData  = result.items // 권리자 목록
            //페이지 수
            const remainder = parseInt(result.filtered % this.userList.pageSize) > 0? 1: 0
            this.userList.totalPage = parseInt(result.filtered /this.userList.pageSize) + remainder

            this.loadingHide()
        }).catch(error=>{
            this.loadingHide()
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
            }
        })
    },
    selectLicensorData(data){
      
      console.log(data);
      if(this.new_licensor.length > 0 && this.new_licensor[0].licensor.id == data.licensor.id){
        this.alert({msg: '양도자로 선택된 권리자 입니다.'})
        return false
      }
      if(this.old_licensor.length > 0 && this.old_licensor[0].licensor.id == data.licensor.id){
        this.alert({msg: '양수자로 선택된 권리자 입니다.'})
        return false
      }
      this.albumList.listData = []
      this.selectAlbum = []
      this.old_licensor = [data]
      this.getUserAlbumList();
      this.closeModal('licensor')
    },
    selectLicensorData2(data){
      if(this.new_licensor.length > 0 && this.new_licensor[0].licensor.id == data.licensor.id){
        this.alert({msg: '양도자로 선택된 권리자 입니다.'})
        return false
      }
      if(this.old_licensor.length > 0 && this.old_licensor[0].licensor.id == data.licensor.id){
        this.alert({msg: '양수자로 선택된 권리자 입니다.'})
        return false
      }
      this.new_licensor = [data]
      this.closeModal('licensor')
    },
    openAlbum(){
      if(this.old_licensor.length < 1){
        this.alert({msg : '양도자를 선택해주세요.'});
        return false
      }
      this.albumList.currentPage = 1
      this.getUserAlbumList();
      this.openModal('album')
    },
    getUserAlbumList(){
        const option = {
          id:this.old_licensor[0].licensor.id,
          params:{
            sort: 'created_at',
            sortorder: 'desc',
            page: this.albumList.currentPage-1 ,
            limit: this.albumList.pageSize
          }
        }
        if( !this.valCheck(this.albumList.keywordType) &&  !this.valCheck(this.albumList.keyword) !='') {
            option.params[this.albumList.keywordType.value] = this.albumList.keyword
        }
        this.loadingShow()
        this.$store.dispatch('GETOFFSETTINGALBUMLIST', option)
        .then(result =>{
            this.albumList.listData  = result.items // 권리자 목록
            //페이지 수
            const remainder = parseInt(result.filtered % this.albumList.pageSize) > 0? 1: 0
            this.albumList.totalPage = parseInt(result.filtered /this.albumList.pageSize) + remainder
            this.albumList.total = result.filtered
            this.loadingHide()
        }).catch(error=>{
            this.loadingHide()
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
            }
        })
    },
  }
}
</script>

<style scoped>

</style>
